export enum EnumOrigemPedido {
  Loja = 'loja',
  Multiloja = 'multiloja'
}
